import { InvestorInspectionMetadata } from '../../../core/models/api.models';

export type MetadataBadgeStatus = 'error' | 'to-correct' | 'todo' | 'completed';

type MetadataBadgeSource = Pick<
  InvestorInspectionMetadata,
  'isAnomaly' | 'isCorrectionCandidate' | 'investorCanBeDeleted'
>;

export function getMetadataBadgeStatus(metadata: MetadataBadgeSource): MetadataBadgeStatus {
  if (metadata.isAnomaly) {
    return 'error';
  }

  if (metadata.isCorrectionCandidate) {
    return 'to-correct';
  }

  if (metadata.investorCanBeDeleted) {
    return 'todo';
  }

  return 'completed';
}

export function getMetadataBadgeLabel(
  metadata: MetadataBadgeSource,
  deletionLabel = 'Éligible suppression'
): string {
  if (metadata.isAnomaly) {
    return 'Anomalie';
  }

  if (metadata.isCorrectionCandidate) {
    return 'Correction';
  }

  if (metadata.investorCanBeDeleted) {
    return deletionLabel;
  }

  return 'Contexte';
}

export function formatNumericList(values: number[], emptyLabel = 'Aucune'): string {
  return values.length > 0 ? values.join(', ') : emptyLabel;
}
